import React, { Component } from "react";
import { Dropdown } from "semantic-ui-react";
import API from "../../../services/Api";
import GetError from "../Response/GetError";
import GetResponse from "../Response/GetResponse";
import { keyToChangeBack, keyToChangeFront, optionsWorkstype, optionsProductsType } from './const';
import PreselectCRUD from './PreselectCRUD';
import ProductBoundCRUD from "./ProductBoundCRUD";

class ConnectedEditProduit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      materiauData: [],
      name: null,
      reference: null,
      code: null,
      resistance: null,
      country: null,
      workstype: [],
      CPT: [],
      productstype: [],
      price: null,
      priority: 0,
      link: null,
      hierarchy: null,
      thick: 0,
      width: 0,
      length: 0,
      heigth: 0,
      diameter: 0,
      m2perpiece: null,
      pieceperpackage: 0,
      m2perpackage: null,
      packageperpalette: 0,
      m2perpalette: null,
      pieceperpalette: 0,
      acermi: null,
      lambda: null,
      error: null,
      response: null,
    };

    // Handle Change
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeReference = this.handleChangeReference.bind(this);
    this.handleChangeCode = this.handleChangeCode.bind(this);
    this.handleChangeResistance = this.handleChangeResistance.bind(this);
    this.handleChangeCpt = this.handleChangeCpt.bind(this);
    this.handleChangeWorkstype = this.handleChangeWorkstype.bind(this);
    this.handleChangeProductstype = this.handleChangeProductstype.bind(this);
    this.handleChangePrice = this.handleChangePrice.bind(this);
    this.handleChangePriority = this.handleChangePriority.bind(this);
    this.handleChangeLink = this.handleChangeLink.bind(this);
    this.handleChangeHierarchy = this.handleChangeHierarchy.bind(this);
    this.handleChangeThick = this.handleChangeThick.bind(this);
    this.handleChangeWidth = this.handleChangeWidth.bind(this);
    this.handleChangeLength = this.handleChangeLength.bind(this);
    this.handleChangeHeigth = this.handleChangeHeigth.bind(this);
    this.handleChangeDiameter = this.handleChangeDiameter.bind(this);
    this.handleChangeM2perpiece = this.handleChangeM2perpiece.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleChangePieceperpackage = this.handleChangePieceperpackage.bind(
      this
    );
    this.handleChangeM2perpackage = this.handleChangeM2perpackage.bind(this);
    this.handleChangePackagePerPalette = this.handleChangePackagePerPalette.bind(
      this
    );
    this.handleChangeM2perPalette = this.handleChangeM2perPalette.bind(this);
    this.handleChangePiecePerPalette = this.handleChangePiecePerPalette.bind(
      this
    );
    this.handleChangeAcermi = this.handleChangeAcermi.bind(this);
    this.handleChangeLambda = this.handleChangeLambda.bind(this);
    this.handleChangeThicknessAfter = this.handleChangeThicknessAfter.bind(this);
    this.handleChangeCoveragePower = this.handleChangeCoveragePower.bind(this);
    this.handleChangeMinimumBag = this.handleChangeMinimumBag.bind(this);
    this.handleChangeBagWeight = this.handleChangeBagWeight.bind(this);
    this.handleChangeBagByPalette = this.handleChangeBagByPalette.bind(this);
    this.handleChangeKiloByPalette = this.handleChangeKiloByPalette.bind(this);
    this.handleChangeThicknessBefore = this.handleChangeThicknessBefore.bind(this);


    // Handle Submit
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    // Retrieving product
    var productId = this.props.match.params.idProduct;
    API.getProduct(productId).then(response => {
      keyToChangeFront.forEach((key, index) => {
        response.data.products[key] = response.data.products[keyToChangeBack[index]];
      });
      response.data.products.cpt = response.data.products.cpt === "OUI" || response.data.products.cpt === "1"
        ? 1
        : 0;

      this.setState(
        {
          ...response.data.products
        }
      );
    });

    window.scrollTo(0, 0);
  }

  handleSave(produitData) {
    var tabCopy = this.state.materiauData;
    tabCopy.push({
      ...produitData
    });
    this.setState({
      materiauData: tabCopy
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    const postData = this.state;

    keyToChangeBack.forEach((key, index) => {
      postData[key] = postData[keyToChangeFront[index]];
    })

    API.modifyProduct(this.props.match.params.idProduct, postData).then(
      res => {
        var response = res.data;
        this.setState({ response });
      }
    );
  }

  handleChangeName(event) {
    this.setState({ name: event.target.value });
  }
  handleChangeReference(event) {
    this.setState({ reference: event.target.value });
  }
  handleChangeCode(event) {
    this.setState({ code: event.target.value });
  }
  handleChangeResistance(event) {
    this.setState({ resistance: event.target.value });
  }
  handleChangeCpt(event) {
    this.setState({ cpt: event.target.value });
  }
  handleChangeWorkstype(event, val) {
    this.setState({ workstype: val.value });
  }
  handleChangeProductstype(event, val) {
    this.setState({ productstype: val.value });
  }
  handleChangePrice(event) {
    this.setState({ price: event.target.value });
  }
  handleChangePriority(event) {
    this.setState({ priority: event.target.value });
  }
  handleChangeLink(event) {
    this.setState({ link: event.target.value });
  }
  handleChangeHierarchy(event) {
    this.setState({ hierarchy: event.target.value });
  }
  handleChangeThick(event) {
    this.setState({ thick: event.target.value });
  }
  handleChangeWidth(event) {
    this.setState({ width: event.target.value });
  }
  handleChangeLength(event) {
    this.setState({ length: event.target.value });
  }
  handleChangeHeigth(event) {
    this.setState({ heigth: event.target.value });
  }
  handleChangeDiameter(event) {
    this.setState({ diameter: event.target.value });
  }
  handleChangeM2perpiece(event) {
    this.setState({ m2perpiece: event.target.value });
  }
  handleChangePieceperpackage(event) {
    this.setState({ pieceperpackage: event.target.value });
  }
  handleChangeM2perpackage(event) {
    this.setState({ m2perpackage: event.target.value });
  }
  handleChangePackagePerPalette(event) {
    this.setState({ packageperpalette: event.target.value });
  }
  handleChangeM2perPalette(event) {
    this.setState({ m2perpalette: event.target.value });
  }
  handleChangePiecePerPalette(event) {
    this.setState({ pieceperpalette: event.target.value });
  }
  handleChangeAcermi(event) {
    this.setState({ acermi: event.target.value });
  }
  handleChangeLambda(event) {
    this.setState({ lambda: event.target.value });
  }

  handleChangeIsolatedCoeff= (e) => {
    this.setState({ isolated_coeff: e.target.value });
  }

  handleChangeThicknessBefore(e) {
    this.setState({ thicknessBefore: e.target.value });
  }
  handleChangeThicknessAfter(e) {
    this.setState({ thicknessAfter: e.target.value });
  }
  handleChangeCoveragePower(e) {
    this.setState({ coveragePower: e.target.value})
  }
  handleChangeMinimumBag(e) {
    this.setState({ minimumBag: e.target.value})
  }
  handleChangeBagWeight(e) {
    this.setState({ bagWeight: e.target.value})
  }
  handleChangeBagByPalette(e) {
    this.setState({ bagByPalette: e.target.value})
  }
  handleChangeKiloByPalette(e) {
    this.setState({ kiloByPalette: e.target.value})
  }

  render() {
    let condition = this.state.error !== null;
    let conditionResponse = this.state.response !== null;

    return (
      <div className="ui container">
        <div className="ui center aligned container">
          <br />
          <h1 className="ui header">Editer un produit</h1>
          <h2 className="ui header">Edit</h2>
          <br />
        </div>

        {condition ? <GetError data={this.state} /> : <div />}

        <div className="ui container stackable three column grid">
          <div className="ui column" />
          <div className="ui column">
            <form className="ui form" onSubmit={this.handleSubmit}>
              <div className="field">
                <label>Nom</label>
                <input
                  placeholder="name"
                  value={this.state.name}
                  onChange={this.handleChangeName}
                />
              </div>
              <div className="field">
                <label>Reference</label>
                <input
                  placeholder="Reference"
                  value={this.state.reference}
                  onChange={this.handleChangeReference}
                />
              </div>
              <div className="field">
                <label>Code</label>
                <input
                  placeholder="Code"
                  value={this.state.code}
                  onChange={this.handleChangeCode}
                />
              </div>
              <div className="field">
                <label>Resistance</label>
                <input
                  placeholder="Resistance"
                  value={this.state.resistance}
                  onChange={this.handleChangeResistance}
                />
              </div>
              <div className="field">
                <label>CPT</label>
                <select onChange={this.handleChangeCpt} value={this.state.cpt}>
                  <option value="1">OUI</option>
                  <option value="0">NON</option>
                </select>
              </div>
              <div className="field">
                <label>Type de travaux</label>
                <Dropdown
                  placeholder=""
                  fluid
                  multiple
                  selection
                  options={optionsWorkstype}
                  onChange={this.handleChangeWorkstype}
                  value={this.state.workstype}
                />
              </div>
              <div className="field">
                <label>Type de produits</label>
                <Dropdown
                  placeholder=""
                  fluid
                  multiple
                  selection
                  options={optionsProductsType}
                  onChange={this.handleChangeProductstype}
                  value={this.state.productstype}
                />
              </div>
              <div className="field">
                <label>Prix</label>
                <input
                  placeholder="price"
                  value={this.state.price}
                  onChange={this.handleChangePrice}
                />
              </div>
              <div className="field">
                <label>Priorite</label>
                <input
                  placeholder="priority"
                  value={this.state.priority}
                  onChange={this.handleChangePriority}
                />
              </div>
              <div className="field">
                <label>Lien pdf</label>
                <input
                  placeholder="Link"
                  value={this.state.link}
                  onChange={this.handleChangeLink}
                />
              </div>
              <div className="field">
                <label>Hierarchie</label>
                <input
                  placeholder="hierarchy"
                  value={this.state.hierarchy}
                  onChange={this.handleChangeHierarchy}
                />
              </div>
              <div className="field">
                <label>Epaisseur</label>
                <input
                  placeholder="thick"
                  value={this.state.thick}
                  onChange={this.handleChangeThick}
                />
              </div>
              <div className="field">
                <label>Largeur</label>
                <input
                  placeholder="width"
                  value={this.state.width}
                  onChange={this.handleChangeWidth}
                />
              </div>
              <div className="field">
                <label>Longueur</label>
                <input
                  placeholder="length"
                  value={this.state.length}
                  onChange={this.handleChangeLength}
                />
              </div>
              <div className="field">
                <label>Hauteur</label>
                <input
                  placeholder="height"
                  value={this.state.heigth}
                  onChange={this.handleChangeHeigth}
                />
              </div>
              <div className="field">
                <label>Diametre</label>
                <input
                  placeholder="diameter"
                  value={this.state.diameter}
                  onChange={this.handleChangeDiameter}
                />
              </div>
              <div className="field">
                <label>M² par piece</label>
                <input
                  placeholder="m2perpiece"
                  value={this.state.m2perpiece}
                  onChange={this.handleChangeM2perpiece}
                />
              </div>
              <div className="field">
                <label>Piece par paquet</label>
                <input
                  placeholder="pieceperpackage"
                  value={this.state.pieceperpackage}
                  onChange={this.handleChangePieceperpackage}
                />
              </div>
              <div className="field">
                <label>M² par paquet</label>
                <input
                  placeholder="m2perpackage"
                  value={this.state.m2perpackage}
                  onChange={this.handleChangeM2perpackage}
                />
              </div>
              <div className="field">
                <label>Paquet par palette</label>
                <input
                  placeholder="packageperpalette"
                  value={this.state.packageperpalette}
                  onChange={this.handleChangePackagePerPalette}
                />
              </div>
              <div className="field">
                <label>M² par palette</label>
                <input
                  placeholder="m2perpalette"
                  value={this.state.m2perpalette}
                  onChange={this.handleChangeM2perPalette}
                />
              </div>
              <div className="field">
                <label>Piece par palette</label>
                <input
                  placeholder="Piece par palette"
                  value={this.state.pieceperpalette}
                  onChange={this.handleChangePiecePerPalette}
                />
              </div>
              <div className="field">
                <label>Epaisseur avant tassement</label>
                <input
                  placeholder="Epaisseur avant tassement"
                  value={this.state.thicknessBefore}
                  onChange={this.handleChangeThicknessBefore}
                />
              </div>
              <div className="field">
                <label>Epaisseur après tassement</label>
                <input
                  placeholder="Epaisseur après tassement"
                  value={this.state.thicknessAfter}
                  onChange={this.handleChangeThicknessAfter}
                />
              </div>
              <div className="field">
                <label>Pouvoir couvrant (kg/m2)</label>
                <input
                  placeholder="Pouvoir couvrant (kg/m2)"
                  value={this.state.coveragePower}
                  onChange={this.handleChangeCoveragePower}
                />
              </div>
              <div className="field">
                <label>Nombre mini de sac pour 100m2</label>
                <input
                  placeholder="Nombre mini de sac pour 100m2"
                  value={this.state.minimumBag}
                  onChange={this.handleChangeMinimumBag}
                />
              </div>
              <div className="field">
                <label>Poids du sac en kg</label>
                <input
                  placeholder="Poids du sac en kg"
                  value={this.state.bagWeight}
                  onChange={this.handleChangeBagWeight}
                />
              </div>
              <div className="field">
                <label>Sac / Palette</label>
                <input
                  placeholder="Sac / Palette"
                  value={this.state.bagByPalette}
                  onChange={this.handleChangeBagByPalette}
                />
              </div>
              <div className="field">
                <label>Kg/palette</label>
                <input
                  placeholder="Kg/palette"
                  value={this.state.kiloByPalette}
                  onChange={this.handleChangeKiloByPalette}
                />
              </div>
              <div className="field">
                <label>Acermi</label>
                <input
                  placeholder="acermi"
                  value={this.state.acermi}
                  onChange={this.handleChangeAcermi}
                />
              </div>
              <div className="field">
                <label>Lambda</label>
                <input
                  placeholder="lambda"
                  value={this.state.lambda}
                  onChange={this.handleChangeLambda}
                />
              </div>
              <div className="field">
                <label>Coefficient d'isolation</label>
                <input
                  placeholder="Coefficient d'isolation"
                  value={this.state.isolated_coeff}
                  onChange={this.handleChangeIsolatedCoeff}
                />
              </div>
              <ProductBoundCRUD
                dataIdProduct={this.props.match.params.idProduct}
              />
              <PreselectCRUD
                productId={this.props.match.params.idProduct}
              />

              <button type="submit" className="ui button" role="button">
                SAUVEGARDER
              </button>
            </form>
          </div>
        </div>

        {conditionResponse ? <GetResponse data={this.state} /> : <div />}
      </div>
    );
  }
}

const EditProduit = ConnectedEditProduit;

export default EditProduit;



// WEBPACK FOOTER //
// ./src/components/Protected/Article/EditProduit.jsx